module.exports = __webpack_public_path__ + "assets/img/aa.3ac91e60.png";